import "../css/returnPolicy.css";
import {
  FaUndoAlt,
  FaBoxOpen,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaClipboardCheck,
  FaExclamationTriangle,
} from "react-icons/fa";

function ReturnPolicy() {
  return (
    <div className="return-page">

      {/* Hero */}

      <section className="return-hero">

        <div className="return-overlay">

          <h1>Return & Refund Policy</h1>

          <p>
            We value customer satisfaction. Please review our return,
            exchange, and refund policy before making a purchase.
          </p>

        </div>

      </section>

      {/* Intro */}

      <section className="return-section">

        <div className="return-container">

          <h2>Our Return Policy</h2>

          <p>
            SIP LIQUORS strives to provide high-quality products. If you
            experience any issue with your order, please contact us
            immediately so we can assist you.
          </p>

        </div>

      </section>

      {/* Cards */}

      <section className="return-section gray">

        <div className="return-container">

          <div className="return-grid">

            <div className="return-card">
              <FaUndoAlt className="return-icon"/>
              <h3>Easy Returns</h3>
              <p>
                Eligible products may be returned within the specified
                return period.
              </p>
            </div>

            <div className="return-card">
              <FaExchangeAlt className="return-icon"/>
              <h3>Exchange</h3>
              <p>
                Damaged or incorrect products may be exchanged based on
                availability.
              </p>
            </div>

            <div className="return-card">
              <FaMoneyBillWave className="return-icon"/>
              <h3>Refunds</h3>
              <p>
                Approved refunds are issued using the original payment
                method whenever possible.
              </p>
            </div>

            <div className="return-card">
              <FaBoxOpen className="return-icon"/>
              <h3>Original Packaging</h3>
              <p>
                Products should be returned in their original condition
                and packaging whenever applicable.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* Rules */}

      <section className="return-section">

        <div className="return-container">

          <h2>Return Guidelines</h2>

          <ul className="return-list">

            <li>✔ Contact customer support before returning any product.</li>

            <li>✔ Provide your order number and purchase details.</li>

            <li>✔ Certain products cannot be returned due to legal or safety regulations.</li>

            <li>✔ Shipping charges may not be refundable unless the error was ours.</li>

            <li>✔ Refund processing times may vary depending on your payment provider.</li>

            <li>✔ Products damaged due to misuse are not eligible for return.</li>

          </ul>

        </div>

      </section>

      {/* Bottom */}

      <section className="return-bottom">

        <div className="return-container">

          <FaClipboardCheck className="bottom-check"/>

          <h2>Need Help With a Return?</h2>

          <p>
            If you have any questions about returns or refunds,
            our customer support team is happy to help.

          </p>

          <FaExclamationTriangle className="bottom-warning"/>

        </div>

      </section>

    </div>
  );
}

export default ReturnPolicy;